import * as React from "react";
import InlineList from "../utils/inline-list";
import UserButton from "../users/user-button";
import PersonButton from "./person-button";

function PersonList({
  persons,
  small = true,
  showLastName,
  sep = null,
  finalSep = <span className="mx-1">and</span>,
} = {}) {
  return (
    <InlineList sep={sep} finalSep={finalSep}>
      {persons.map((person) =>
        person.user ? (
          <UserButton
            user={person.user}
            showLastName={showLastName}
            small={small}
            key={person.user.id}
          />
        ) : (
          <PersonButton person={person} small={small} key={person.name} />
        )
      )}
    </InlineList>
  );
}

export default PersonList;
